
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/CategoryPage/CategoryPage",
      function () {
        return require("private-next-pages/community/CategoryPage/CategoryPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/CategoryPage/CategoryPage"])
      });
    }
  